import { getToken } from "./service";
import axios from "axios";
import qs from "qs";
import Config from "../config";
import Storage from "../utils/Storage";

export interface MarkItem {
    id: number;
    mark: string;
}

export interface RollCallItem {
    studentId: number;
    studentNo: string;
    name: string;
    className: string;
    markList: MarkItem[];
}

export function getStudentsByWeekTimeId(weekTimeId: number) {
    const token = getToken();
    return axios
        .get<SuccessData<RollCallItem[]>>(
            `/teacher/getStudentsByWeekTimeId?${qs.stringify({ weekTimeId })}`,
            { headers: { token } }
        )
        .then(res => res.data.data);
}

/**
 * 给学生打标签
 * @param studentId
 * @param weekTimeId
 * @param mark
 */
export function makeStuTag(
    studentId: string,
    weekTimeId: number,
    mark: string
) {
    const token = getToken();
    const params = { studentId, weekTimeId, mark: mark.trim() };
    return axios.post<SuccessData<RollCallItem[]>>(
        `/teacher/makeStuTag`,
        qs.stringify(params),
        { headers: { token } }
    );
}

/**
 * 导出选人活动
 * @param weekTimeId
 */
export function exportStuMark(weekTimeId: number) {
    const token = getToken();
    window.open(
        `${
            Config.ApiHost
        }teacher/exportStuMark?weekTimeId=${weekTimeId}&token=${encodeURIComponent(
            token!
        )}`
    );
}

/**
 * 删除标签
 * @param markId
 */
export function deleteStuTag(markId: number) {
    const token = getToken();
    const params = { markId };
    return axios.post<SuccessData<RollCallItem[]>>(
        `/teacher/deleteStuTag`,
        qs.stringify(params),
        { headers: { token } }
    );
}

/**
 *保存随机点名记录数
 */

export function saveRandomCount(
    courseNo: string,
    courseSeq: string,
    weekTimeId: number
) {
    const token = getToken();
    const params = { courseNo, courseSeq, weekTimeId };
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    return axios.post<SuccessData<RollCallItem[]>>(
        `/teacher/student/saveRandomCount`,
        qs.stringify(params),
        { headers: { token, batchNo } }
    );
}
